import { useState } from "react";

import Button from "../../../../../common/Button";
import { getViewDownloadLinkForProcoDocs } from "../../../../../../lib/fetchApi";
import { documentHasFileId } from "../../../../../../lib/docs";
import { caseActions } from "../../../../../../store/case";
import { useDispatch } from "react-redux";
export default function ViewDocument({children, userToken, activeCase, item, btnStyle, extraAction, docType, title = 'View document'}) {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    if (!documentHasFileId(item)) {
        return null
    }

    async function viewDocumentHandler() {
        setLoading(true)
        let doc = await getViewDownloadLinkForProcoDocs(userToken, activeCase.case.id, docType, item.id)

        if (doc && doc.view_url) {
            var win = window.open(doc?.view_url, '_blank');
            win.focus();

            // Only Law Firm uploads track "viewed" — ProCo source docs must stay unviewed
            if (item.source === 'Law Firm') {
                dispatch(caseActions.markDocumentAsViewed(item))
            }
        }
        if (extraAction) {
            extraAction()
        }
        setLoading(false)
    }
    return <Button title={title} btnStyle={btnStyle} click={viewDocumentHandler} isLoading={loading} loaderType={'dark'}>{children}</Button>
}